var $ = require('jquery');
var webfontloader = require('./libs/webfontloader-1.6.28.js');
var lazysizes = require('./libs/lazysizes-5.3.0.js');
var splide = require('./libs/splide.min.js');
var header_height = require('./header-height.js');
var jpScrollDirection = require('./libs/jpScrollDirection.js');

// Load the YouTube IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

webfontloader.load({
	// GOOGLE FONTS
	google: {
		families: [
			'Barlow Condensed:300,400,500,600,700'
		]
	},
	// TYPEKIT
	typekit: { id: 'mkv5wvz' },
	// CALLBACK WHEN FONTS LOAD
	// active: ali_fonts_active_cb
});

// Callback function for when the fonts are loaded.
function ali_fonts_active_cb(){

}

// Use lazysizes to get lazy loading on css background images.
document.addEventListener('lazybeforeunveil', function(e){
	var bg = e.target.getAttribute('data-bg');
	if(bg){
			e.target.style.backgroundImage = 'url(' + bg + ')';
	}
});

// Detect if windows
try {
	if( navigator.platform.indexOf('Win') > -1 ){
		document.documentElement.classList.add('is-windows');
	}
}
catch(error){
	console.log('Error detecting OS:');
	console.log(error);
}

// Templates
var search_js = require('./search.js');

// Components
var navigation_js = require('./components/navigation.js');
var navigation_js = require('./components/site-header.js');
var related_stories = require('./components/related-stories.js');
var searchform = require('./components/searchform.js');

// Layouts
var content_listing_js = require('./layouts/content-listing.js');
var content_promos_js = require('./layouts/content-promos.js');
var article_showcase_js = require('./layouts/hero--article-showcase.js');
var video_js = require('./layouts/video.js');
var people_listing_js = require('./layouts/people-listing.js');


window.onYouTubeIframeAPIReady = function () {
	// console.log('####################### YouTubeIframeAPIReady');

	window.onYouTubeIframeAPIReady_video_js();

}
